// extracted by mini-css-extract-plugin
module.exports = {"version-row":"VersionsModal_version-row__3LSGq","versionRow":"VersionsModal_version-row__3LSGq"};